import {
  startOfDay,
  endOfDay,
  subDays,
  addDays,
  endOfMonth,
  isSameDay,
  isSameMonth,
  addHours
} from 'date-fns';
import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy, ViewChild, TemplateRef } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { CalendarEventsService } from '../../../../shared/services/calendarEvent.service';
import { Router, ActivatedRoute } from '@angular/router';
import { CognitoUtil } from '../../../../shared/services/cognito.service';
import { LocalUserService } from '../../../../shared/services/localUser';
import { CaseService } from '../../../../shared/services/case.service';
import { Case } from '../../../../shared/models/case';
import { MatDialog, MatDialogRef } from '@angular/material';
import { EguardCalendarEventFormatialogComponent } from '../event-form/event-form.component';
import { FormGroup } from '@angular/forms';
import { CalendarEventModel } from './event.model';
import { OrganizationServices } from '../../../../shared/services/organization.services';
import {
  CalendarEvent,
  CalendarEventAction,
  CalendarEventTimesChangedEvent,
  CalendarMonthViewDay
} from 'angular-calendar';
import { EguardConfirmatialogComponent } from '../../../../../core/components/confirm-dialog/confirm-dialog.component';
import { eguardAnimations } from '../../../../../core/animations';
import { MatSnackBar } from '@angular/material';
import { environment } from '../../../../../../environments/environment';
import { element } from 'protractor';
import { ConfirmationDialogComponent } from '../../../../shared/dialog/confirmation-dialog/confirmation-dialog.component';
import { HeaderTitleService } from 'app/services/header-title.service';

@Component({
  selector: 'eguard-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: eguardAnimations,
  providers: [
    LocalUserService
  ]
})
export class EguardCalendarComponent implements OnInit {

  view: string;
  token: string;
  viewDate: Date;
  orgId: string;
  userId: string;
  role: string;
  selectedDate: any;
  selectedMonth: number;
  selectedYear: number;

  allUsers = [];
  enabledUsers = [];
  dropdownSettings = {};
  selectedUsers = [];
  selectedEvents = [];
  isSelectedUser = [];
  isLoading = false;
  currentMonth;
  currentYear;
  addUserEvents: any;
  orgEvents = false;
  myEvents = true;
  associateUser = false;
  colorList = ['#ADFF2F', '#7FFF00', '#32CD32', '	#00ff00', '#006400',
    '	#6495ED', '#00BFFF', '	#4169E1', '#0000FF', '#00008B',
    '	#D2691E', '#8B4513', '	#A0522D', '#A52A2A', '#800000',
    '#DCDCDC', '#808080', '#778899', '#708090', '#2F4F4F'];

  events = [];
  public actions: CalendarEventAction[];

  activeDayIsOpen: boolean;

  refresh: Subject<any> = new Subject();

  dialogRef: any;

  selectedDay: any;
  allEvents: any;
  show = true;
  casesArray = [];

  allOrgEvents = [];
  error: string;
  users: string[] = []
  orgUsers: any[] = [];
  sharedNames: {
    id: string,
    name: string
  }[] = [];
  constructor(
    public dialog: MatDialog,
    private cognitoUtil: CognitoUtil,
    private router: Router,
    private calendarEventsService: CalendarEventsService,
    private organizationServices: OrganizationServices,

    public snackBar: MatSnackBar,
    private caseService: CaseService,

    private localUser: LocalUserService,
    private headerService: HeaderTitleService
  ) {
    this.allEvents = [];
    this.view = 'week';
    this.viewDate = new Date();
    this.selectedDay = { date: startOfDay(new Date()) };

    this.setEvents();
  }


  getAllUsers(orgID: string) {
    this.isLoading = true;
    this.organizationServices.getUsersInOrganization(orgID)
      .subscribe(page => {
        this.orgUsers = page || [];
        this.allUsers = page || [];
        this.setSharedUsersNames();
        this.isLoading = false;
      });
  }

  setSharedUsersNames() {
    this.isLoading = true;
    this.sharedNames = [];
    this.users.forEach((userId) => {
      let user = this.orgUsers.find(user => user.id == userId)
      if (user) {
        let item = {
          id: user.id,
          name: user.first_name + user.last_name
        }
        this.sharedNames.push(item);
      }
    })
    this.isLoading = false;
  }
  ngOnInit() {
    this.userId = this.localUser.getUserId();
    this.orgId = this.localUser.getOrganizationId();
    this.role = this.localUser.getRole();

    this.selectedDate = new Date();
    this.currentMonth = this.selectedDate.getMonth() + 1;
    this.currentYear = this.selectedDate.getFullYear();
    this.viewDate = new Date();
    this.selectedDay = { date: startOfDay(new Date()) };
    this.renderCalendar(this.currentMonth, this.currentYear);
    this.getAllAssociatedUsers();
    if (this.orgId && this.role.toLowerCase() === 'clerk') {
      this.getAllUsers(this.orgId)
    }

    if (this.role === 'CLERK' || this.role === 'JUDGE') {
      this.showCases();
    }
    else {
      this.getUserCases();
    }
    setTimeout(() => { this.sendHeaders(); });
  }
  sendHeaders(): void {
    this.headerService.sendHeader('today', 'Calendar')
  }

  selectedList($event) {
    this.users = $event.map(item => item.id);
  }

  showCases() {
    this.isLoading = true;
    this.caseService.getAllCases(this.orgId)
      .subscribe(result => {
        this.casesArray = result;
      });
  }

  getUserCases() {
    this.caseService.getCasesByUserId(this.orgId, this.userId)
      .subscribe(result => {
        this.casesArray = result;
      });
  }

  setEvents() {
    this.events = this.allEvents.map(item => {
      item.actions = this.actions;
      return new CalendarEventModel(item);
    });
  }

  onCalendarSelectedChange(date) {
  }

  fetchEvents() {
    this.renderCalendar(this.currentMonth, this.currentYear);
  }
  onSelect(event) {
    this.isLoading = true;
    this.selectedDate = event;
    this.viewDate = event;
    this.isLoading = false;
    this.selectedMonth = this.viewDate.getMonth() + 1;
    this.selectedYear = this.viewDate.getFullYear();
    this.currentMonth = this.selectedMonth;
    this.currentYear = this.selectedYear;
    this.renderCalendar(this.selectedMonth, this.selectedYear);
  }

  changeTimeFrame($event) {
    this.selectedDay = { date: $event };
    let date = new Date(this.viewDate);
    this.currentMonth = date.getMonth() + 1;
    this.currentYear = date.getFullYear();
    this.renderCalendar(this.currentMonth, this.currentYear);
  }

  beforeMonthViewRender({ header, body }) {
    const _selectedDay = body.find(_day => {
      return _day.date.getTime() === this.selectedDay.date.getTime();
    });
    if (_selectedDay) {
      _selectedDay.cssClass = 'mat-elevation-z3';
    }
  }

  dayClicked(day: CalendarMonthViewDay): void {
    const date: Date = day.date;
    const events: CalendarEvent[] = day.events;
    if (isSameMonth(date, this.viewDate)) {
      if ((isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) || events.length === 0) {
        this.activeDayIsOpen = false;
      }
      else {
        this.activeDayIsOpen = true;
        this.viewDate = date;
      }
    }
    this.selectedDay = day;
    this.refresh.next();
  }

  eventTimesChanged({ event, newStart, newEnd }: CalendarEventTimesChangedEvent) {

    let id = event.meta.id;

    event.start = newStart;
    event.end = newEnd;

    let jsonObject = JSON.parse(JSON.stringify(event));
    jsonObject.id = id;

    if (jsonObject.meta.user_ids === '') {
      jsonObject.meta.user_ids = [];
    }
    delete jsonObject.meta['id'];
    this.calendarEventsService.putEvent(jsonObject, id, this.orgId, this.userId)
      .subscribe(data => {
      }, error => {
        this.isLoading = false;
        this.error = 'This page had an error please refresh if this continues contact support';
        this.snackBar.open(this.error, '', {
          duration: environment.snackBarErrorLength,
        });
      });
    jsonObject.meta['id'] = id;
    this.refresh.next(true);
  }

  editEvent(action: string, event: any) {
    let statusType = 'event';
    if (event.event.end === null || event.event.end === undefined) {
      statusType = 'task';
    }
    this.dialogRef = this.dialog.open(EguardCalendarEventFormatialogComponent, {
      panelClass: 'event-form-dialog',
      data: {
        event: event.event,
        action: action,
        statusType: statusType,
        createdBy: event.event.created_by,
        cases: this.casesArray
      }
    });
    this.dialogRef.afterClosed().subscribe(response => {
      if (response == true) {
        this.renderCalOffViewDate();
      }
    });
  }

  addEvent(statusType: string) {
    this.dialogRef = this.dialog.open(EguardCalendarEventFormatialogComponent, {
      panelClass: 'event-form-dialog',
      data: {
        action: 'new',
        date: this.selectedDay.date,
        statusType: statusType,
        cases: this.casesArray

      }
    });
    this.dialogRef.afterClosed().subscribe((response: FormGroup) => {
      this.renderCalOffViewDate();
    });
  }

  renderCalOffViewDate() {
    let date = new Date(this.viewDate);

    this.renderCalendar(date.getMonth() + 1, date.getFullYear());
  }

  addDate() {
  }

  // getAllUsers(orgID: string) {
  //   this.organizationServices.getUsersInOrganization(orgID)
  //     .subscribe(data => {
  //       this.allUsers = data;
  //     });
  // }


  getOtherCalendarEvent(user) {
    this.calendarEventsService.getEventsByUser(user.userId, this.currentYear, this.currentMonth)
      .subscribe(data => {
        if (user.enabled == true) {
          data = data.map(event => {
            event.color = event.color || {};
            event.color.primary = user.color;
            event.color.secondary = user.color;
            return event;
          });
          this.getAllEvents(user.userId, data);
        } else {
          this.enabledUsers = this.enabledUsers.filter(element => element.id !== user.userId);

        }
      }, error => {
        this.isLoading = false;
        this.error = 'This page had an error please refresh if this continues contact support';
        this.snackBar.open(this.error, '', {
          duration: environment.snackBarErrorLength,
        });
      });
    if (this.selectedDate.getDate() >= 25) {
      let month, year
      if (this.currentMonth === 12) {
        month = 1
        year = this.currentYear + 1;
      } else {
        month = this.currentMonth + 1
        year = this.currentYear
      }
      this.calendarEventsService.getEventsByUser(user.userId, year, month)
        .subscribe(data => {
          if (user.enabled == true) {
            data = data.map(event => {
              event.color = event.color || {};
              event.color.primary = user.color;
              event.color.secondary = user.color;
              return event;
            });
            this.getAllEvents(user.userId, data);
          } else {
            this.enabledUsers = this.enabledUsers.filter(element => element.id !== user.userId);

          }
        })
    }
  }

  getAllEvents(userId, events) {
    const obj = {
      id: userId,
      data: events
    };
    this.enabledUsers = this.enabledUsers.filter(element => element.id !== userId);
    this.enabledUsers.push(obj);
    this.mergeEvents();
  }

  mergeEvents() {
    this.selectedEvents = [];
    this.enabledUsers.forEach(item => {
      if (item.id === this.userId) {
        item.data.forEach(item => {
          this.selectedEvents.push(item);
        });
      } else {
        item.data.forEach(item => {
          this.selectedEvents.push(item);
        });
      }
    });
    this.readEvents(this.selectedEvents);
  }

  renderCalendar(month, year) {

    if ((this.role === 'CLERK' || this.role === 'JUDGE') && this.orgEvents == true) {
      this.isLoading = true;
      this.calendarEventsService.getEventsByOrganization(this.orgId, year, month)
        .subscribe(data => {
          data = data.map(event => {
            event.color = event.color || {};
            event.color.primary = '#1e90ff';
            event.color.secondary = '#1e90ff';
            return event;
          });
          data.forEach(item => {
            this.allOrgEvents.push(item)
          })
          this.isLoading = false
          this.readEvents(this.allOrgEvents);
          // this.getAllAssociatedUsers();
        }, error => {
          this.isLoading = false;
          this.error = 'This page had an error please refresh if this continues contact support';
          this.snackBar.open(this.error, '', {
            duration: environment.snackBarErrorLength,
          });
        });

      if (this.selectedDate.getDate() >= 25) {
        if (month === 12) {
          month = 1
          year = year + 1;
        } else {
          month = month + 1
        }
        this.isLoading = true;
        this.calendarEventsService.getEventsByOrganization(this.orgId, year, month)
          .subscribe(data => {
            data = data.map(event => {
              event.color = event.color || {};
              event.color.primary = '#1e90ff';
              event.color.secondary = '#1e90ff';
              return event;
            });
            data.forEach(item => {
              this.allOrgEvents.push(item)
            })
            this.isLoading = false;
            this.readEvents(this.allOrgEvents);
          }, error => {
            this.isLoading = false;
            this.error = 'This page had an error please refresh if this continues contact support';
            this.snackBar.open(this.error, '', {
              duration: environment.snackBarErrorLength,
            });
          });
      }


    }
    else {
      this.isLoading = true;
      this.calendarEventsService.getEventsByUser(this.userId, this.currentYear, this.currentMonth)
        .subscribe(data => {
          this.getAllEvents(this.userId, data);
        }, error => {
          this.isLoading = false;
          this.error = 'This page had an error please refresh if this continues contact support';
          this.snackBar.open(this.error, '', {
            duration: environment.snackBarErrorLength,
          });
        });
      if (this.selectedDate.getDate() >= 25) {
        if (month === 12) {
          month = 1
          year = year + 1;
        } else {
          month = month + 1
        }
      }
    }
  }

  organizationEvents(orgEvents) {
    if (orgEvents === true) {
      this.renderCalendar(this.currentMonth, this.currentYear);
    }
    else {
      this.allOrgEvents = [];
      this.getAllAssociatedUsers();
    }
  }

  readEvents(events) {
    let loadEvents = [];
    if (events.length) {
      for (let i = 0; i < events.length; i++) {
        loadEvents = loadEvents.filter(element => (element.title !== events.title))
        let calendarObject = events[i];

        let model = {
          title: calendarObject.title,
          start: new Date(calendarObject.start),
          created_by: calendarObject.created_by,
          end: calendarObject.end === null ? null : new Date(calendarObject.end),
          color: {
            primary: calendarObject.color == null ? '#1e90ff' : calendarObject.color.primary == '#1e90ff' ? '#1e90ff' : calendarObject.color.primary,
            secondary: calendarObject.color == null ? '#D1E8FF' : calendarObject.color.secondary == '#D1E8FF' ? '#1e90ff' : calendarObject.color.secondary,
          },
          allDay: calendarObject.allDay,
          meta: {
            location: calendarObject.meta.location,
            notes: calendarObject.meta.notes,
            id: calendarObject.id,
            cases: calendarObject.meta.cases,
            user_ids: calendarObject.meta.user_ids
          },
          resizable: {
            beforeStart: true,
            afterEnd: true
          },
          draggable: true
        };
        loadEvents.filter(item => item.title !== model.title && item.created_by !== model.created_by)
        loadEvents.push(model);
        this.isLoading = false;
      }
    }
    else {
      this.isLoading = false;
    }

    // replaces current events
    this.isLoading = false;
    this.events = loadEvents;
  }

  addUser(user) {
    this.selectedUsers.push(user);
  }

  addAssociatedUser(userId) {
    this.users.forEach(element => {
      let u = this.allUsers.find(name => name.id === element);
      let userName = u.first_name + " " + u.last_name; 
      let model = {
        enabled: true,
        userId: u.id,
        name: userName,
        color: '#00ff00',
      };
      this.isLoading = true;
      let existingUser = this.isSelectedUser.find(e => e.userId == u.id)
      if (existingUser) {
        this.error = 'User Already exists';
        this.snackBar.open(this.error, '', {
          duration: 2000,
        });
        this.addUserEvents = null
      }
      else {
        this.calendarEventsService.addAssociateUser(this.userId, model)
          .subscribe(data => {
            this.getAllAssociatedUsers();
            this.addUserEvents = null
          }, error => {
            this.isLoading = false;
            this.error = 'This page had an error please refresh if this continues contact support';
            this.snackBar.open(this.error, '', {
              duration: environment.snackBarErrorLength,
            });
          });
      }
    });
    
  }
  getAllAssociatedUsers() {
    this.calendarEventsService.getAssociatedUser(this.userId)
      .subscribe(data => {
        this.isSelectedUser = data;
        if (data.length > 0) {
          data.forEach(user => {
            this.getOtherCalendarEvent(user);
          });
        } else {
          this.mergeEvents()
        }
      }, error => {
        this.error = 'This page had an error please refresh if this continues contact support';
        this.isLoading = false;
        this.snackBar.open(this.error, '', {
          duration: environment.snackBarErrorLength,
        });
      });
  }

  enableUser(checked, associateId, color) {
    this.updateAssociate(!checked, associateId, color);
  }
  updateAssociate(checked, associateId, color) {


    let userName = this.allUsers.find(name => name.id === associateId);
    let model = {
      enabled: checked,
      userId: associateId,
      name: userName.first_name,
      color: color,
    };
    this.isLoading = true;
    this.calendarEventsService.addAssociateUser(this.userId, model)
      .subscribe(data => {
        this.getAllAssociatedUsers();

      }, error => {
        this.isLoading = false;
        this.error = 'This page had an error please refresh if this continues contact support';
        this.snackBar.open(this.error, '', {
          duration: environment.snackBarErrorLength,
        });
      });
  }

  deleteUser(associateId) {
    const confirmDialog = this.dialog.open(ConfirmationDialogComponent,{
      panelClass:"confirmDetails"

    });
    confirmDialog.componentInstance.msg = `Are you sure to want to remove this user ?`;

    confirmDialog.afterClosed().subscribe(response => {
      if (response == true) {
        this.isLoading = true;
        this.calendarEventsService.removeAssociatedUser(this.userId, associateId)
          .subscribe(data => {
            this.isSelectedUser = this.isSelectedUser.filter(element => element.userId !== associateId);
            this.enabledUsers = this.enabledUsers.filter(element => element.id !== associateId);
            this.mergeEvents();
          }, error => {
            this.isLoading = false;
            this.error = 'This page had an error please refresh if this continues contact support';
            this.snackBar.open(this.error, '', {
              duration: environment.snackBarErrorLength,
            });
          });
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/main/content/common/calendar/calendar-view/calendar.component.ts